export default function AboutSection() {
  return (
    <section id="quem-somos" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        {/* Image */}
        <div className="relative">
          <div className="rounded-lg overflow-hidden">
            <img
              src="https://public.readdy.ai/ai/img_res/b35d2a986768ad47eafd169f79161df3.jpg"
              alt="Equipe Solus IT"
              className="w-full h-80 object-cover object-top"
            />
          </div>
          {/* Badge */}
          <div className="absolute -bottom-5 -right-5 solus-gradient-bg text-white px-6 py-4 rounded-lg solus-glow">
            <div className="text-3xl font-black">17+</div>
            <div className="text-xs font-medium opacity-90">Anos no mercado</div>
          </div>
        </div>

        {/* Text */}
        <div>
          <div className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest mb-4" style={{ color: '#4C86C2' }}>
            <div className="w-6 h-px solus-gradient-bg"></div>
            Quem Somos
          </div>
          <h2 className="text-4xl font-black text-[#000000] leading-tight mb-6">
            Especialistas em{" "}
            <span className="solus-gradient-text">transformação digital</span>{" "}
            para empresas
          </h2>
          <p className="text-[#000000]/60 leading-relaxed mb-5">
            A Solus IT é uma empresa especializada em soluções tecnológicas para evolução dos negócios através de consultoria personalizada. Oferecemos para sua empresa um diagnóstico completo e o planejamento integrado com a TI através da contratação de nossos planos de forma de consultoria, que possibilita otimização do tempo e a demanda de cada cliente.
          </p>
          <p className="text-[#000000]/60 leading-relaxed mb-8">
            Atuamos em todo o Brasil, com forte presença na Região Norte, sendo referência em inovação, agilidade e desenvolvimento de processos de transformação digital, sempre colocando o cliente no centro de cada decisão.
          </p>
          <p className="text-[#000000]/60 leading-relaxed mb-8">
            Contamos com uma equipe altamente qualificada e respaldada por certificações reconhecidas pelo mercado, como MPS.Br-SV nível F, PMP, Dell Technology Architect em Storage Solutions, Fortinet NSE 6 e NSE 7, além de certificações em ITIL 4, Nutanix Professional, Trend Micro, Extreme Networks e Siemon. Essa expertise é fortalecida por nossas alianças estratégicas com os principais fabricantes do setor, com destaque para as parcerias Dell Platinum, Fortinet Advanced e SUSE Emerald, o que reforça nossa capacidade de entregar soluções seguras, inovadoras e aderentes às necessidades de cada cliente.
          </p>

          <div className="grid grid-cols-2 gap-4">
            {[
              { icon: "ri-shield-check-line", label: "Certificações reconhecidas" },
              { icon: "ri-customer-service-2-line", label: "Suporte especializado" },
              { icon: "ri-time-line", label: "Atendimento ágil" },
              { icon: "ri-team-line", label: "Equipe qualificada" },
            ].map((item) => (
              <div key={item.label} className="flex items-center gap-3">
                <div
                  className="w-9 h-9 flex items-center justify-center rounded-md"
                  style={{ background: 'rgba(98,169,224,0.12)', color: '#4C86C2' }}
                >
                  <i className={`${item.icon} text-lg`}></i>
                </div>
                <span className="text-sm font-medium text-[#000000]">{item.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
